import api from '../../api/countries';

export default {
    state: {
        telcodes: null,
    },
    getters: {
        getTelCodes: (state) => state.telcodes,
    },
    mutations: {
        SET_TEL_CODES_DATA(state, payload) {
            state.telcodes = payload;
        },
    },
    actions: {
        fetchTelCodes({
            commit
        }) {
            api.getTelCodes().then(({
                data: {
                    data: {
                        telcodes
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_TEL_CODES_DATA', Object.values(telcodes));
                }
            });
        }
    },
};